import AdminScreen from "./admin-screen";

export  default AdminScreen